import { render, staticRenderFns } from "./SeoConfig.vue?vue&type=template&id=7d83f046&"
import script from "./SeoConfig.vue?vue&type=script&lang=js&"
export * from "./SeoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d83f046')) {
      api.createRecord('7d83f046', component.options)
    } else {
      api.reload('7d83f046', component.options)
    }
    module.hot.accept("./SeoConfig.vue?vue&type=template&id=7d83f046&", function () {
      api.rerender('7d83f046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/seo-config/SeoConfig.vue"
export default component.exports